export const LONGSTAY_HREFLANG_LINKS = [
  { rel: "alternate", hrefLang: "th", href: "https://thainotarylaw.com/longstay" },
  { rel: "alternate", hrefLang: "en", href: "https://thainotarylaw.com/en/longstay" },
  { rel: "alternate", hrefLang: "zh", href: "https://thainotarylaw.com/zh/longstay" },
  { rel: "alternate", hrefLang: "ja", href: "https://thainotarylaw.com/ja/longstay" },
  { rel: "alternate", hrefLang: "ko", href: "https://thainotarylaw.com/ko/longstay" },
  { rel: "alternate", hrefLang: "vi", href: "https://thainotarylaw.com/vi/longstay" },
  { rel: "alternate", hrefLang: "id", href: "https://thainotarylaw.com/id/longstay" },
  { rel: "alternate", hrefLang: "x-default", href: "https://thainotarylaw.com/longstay" },
];
